(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eigene_tools"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.getElementById('nm-tools-{{ section.id }}');
  if(!root) return;
  // Keine zusätzliche JS-Init nötig – alles im Inline-Script der Section
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gravur-vektorisierer"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Wait for both DOM and Potrace library to load
  function waitForPotrace() {
    if (typeof Potrace === 'undefined' || document.readyState !== 'complete') {
      setTimeout(waitForPotrace, 50);
      return;
    }
    initializeVectorizer();
  }

  function initializeVectorizer() {
    console.log("VECTORIZER: Skript-Block wird ausgeführt.");
    console.log("VECTORIZER: Potrace type:", typeof Potrace);
    console.log("VECTORIZER: Potrace object:", Potrace);

    if (typeof Potrace === 'undefined') {
      console.error("VECTORIZER: Die Potrace-Bibliothek wurde nicht geladen.");
      const svgOutputContainer = document.getElementById('svg-output');
      if (svgOutputContainer) {
          svgOutputContainer.innerHTML = '<p style="color: red;">Fehler: Die Potrace-Bibliothek wurde nicht geladen.</p>';
      }
      return;
    }

    if (typeof Potrace !== 'function' && typeof Potrace !== 'object') {
      console.error("VECTORIZER: Die Potrace-Bibliothek hat einen unerwarteten Typ.");
      const svgOutputContainer = document.getElementById('svg-output');
      if (svgOutputContainer) {
          svgOutputContainer.innerHTML = '<p style="color: red;">Fehler: Die Potrace-Bibliothek hat einen unerwarteten Typ.</p>';
      }
      return;
    }
    
    console.log("VECTORIZER: Potrace-Bibliothek ist bereit. Initialisiere das Werkzeug.");

    // Get all DOM elements
    const imageUploadInput = document.getElementById('image-upload-input');
    const sourceImage = document.getElementById('sourceImage');
    const svgOutputContainer = document.getElementById('svg-output');
    const controlsWrapper = document.getElementById('controls-wrapper');
    const fileNameDisplay = document.getElementById('file-name-display');
    const uploadPrompt = document.querySelector('.upload-prompt');

    if (!imageUploadInput || !sourceImage || !svgOutputContainer) {
      console.error("FEHLER: Ein oder mehrere benötigte HTML-Elemente wurden nicht gefunden.");
      return;
    }

    // Store original SVG for comparison
    let originalSvgString = '';
    let currentSvgElement = null;
    
    // Event Listener for file upload
    imageUploadInput.addEventListener('change', function(event) {
      const file = event.target.files[0];
      if (file) {
        if (uploadPrompt) uploadPrompt.style.display = 'none';
        svgOutputContainer.innerHTML = '<p>Bild wird verarbeitet...</p>';
        fileNameDisplay.textContent = `Datei: ${file.name}`;
        controlsWrapper.style.display = 'none';
        
        // Process the file directly with Potrace
        processImageWithPotrace(file);
      }
    });

    sourceImage.onerror = function() {
      svgOutputContainer.innerHTML = '<p>Fehler: Die Bilddatei ist beschädigt oder hat ein nicht unterstütztes Format.</p>';
    };

    function processImageWithPotrace(file) {
      try {
        console.log("VECTORIZER: Starte Bildverarbeitung mit Potrace");
        
        // Create a temporary canvas to preprocess the image
        const tempCanvas = document.createElement('canvas');
        const tempCtx = tempCanvas.getContext('2d');
        const img = new Image();
        
        img.onload = function() {
          console.log("VECTORIZER: Bild geladen - Größe:", img.width, "x", img.height);
          
          // Set canvas size to match image
          tempCanvas.width = img.width;
          tempCanvas.height = img.height;
          
          console.log("VECTORIZER: Canvas Größe gesetzt:", tempCanvas.width, "x", tempCanvas.height);
          
          // Fill with white background first
          tempCtx.fillStyle = 'white';
          tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
          
          // Apply image smoothing for better line continuity
          tempCtx.imageSmoothingEnabled = true;
          tempCtx.imageSmoothingQuality = 'high';
          
          // Draw the image on top
          tempCtx.drawImage(img, 0, 0, img.width, img.height);
          
          // Apply slight blur to connect small gaps in lines
          tempCtx.filter = 'blur(0.5px)';
          tempCtx.globalCompositeOperation = 'multiply';
          tempCtx.drawImage(tempCanvas, 0, 0);
          tempCtx.filter = 'none';
          tempCtx.globalCompositeOperation = 'source-over';
          
          // Convert canvas to blob and process with Potrace
          tempCanvas.toBlob(function(blob) {
            console.log("VECTORIZER: Blob erstellt, Größe:", blob.size, "bytes");
            
            // Get current parameter values
            const detailLevel = document.getElementById('detail-slider') ? parseInt(document.getElementById('detail-slider').value) : 2;
            const cornerSmoothing = document.getElementById('corner-slider') ? parseFloat(document.getElementById('corner-slider').value) : 1.0;
            
            // Set parameters for better vectorization with user controls
            Potrace.setParameter({
              turnpolicy: "minority",
              turdsize: Math.max(0, 10 - detailLevel),  // More detail = smaller turd size
              optcurve: true,
              alphamax: cornerSmoothing,  // User-controlled corner smoothing
              opttolerance: 0.1 / cornerSmoothing  // Inverse relationship for smoother curves
            });
            
            console.log('VECTORIZER: Potrace Parameter - Detail:', detailLevel, 'Corner:', cornerSmoothing);
            
            // Load preprocessed image
            Potrace.loadImageFromFile(blob);
            
            // Store image dimensions for later use
            window.currentImageDimensions = {
              width: img.width,
              height: img.height
            };
            
            // Process and get result
            Potrace.process(function() {
          try {
            console.log("VECTORIZER: Potrace Verarbeitung abgeschlossen");
            
            let svgString = Potrace.getSVG(1);
            console.log("VECTORIZER: SVG generiert:", svgString.substring(0, 200) + "...");
            
            if (!svgString || svgString.trim() === '') {
              throw new Error("Leere SVG generiert - möglicherweise ist das Bild zu hell oder zu dunkel.");
            }
            
            const parser = new DOMParser();
            const svgDoc = parser.parseFromString(svgString, "image/svg+xml");
            const svgElement = svgDoc.querySelector('svg');
            const pathElements = svgDoc.querySelectorAll('path');
            
            if (!svgElement) {
              throw new Error("SVG-Element konnte nicht erstellt werden.");
            }
            
            if (pathElements.length === 0) {
              throw new Error("Keine Pfade gefunden - versuchen Sie ein kontrastreicheres Bild.");
            }
            
            // Ensure SVG has correct dimensions
            console.log("VECTORIZER: Original SVG dimensions:", svgElement.getAttribute('width'), svgElement.getAttribute('height'));
            console.log("VECTORIZER: SVG viewBox:", svgElement.getAttribute('viewBox'));
            
            // Set proper dimensions using stored dimensions
            const storedDims = window.currentImageDimensions;
            if (storedDims) {
              svgElement.setAttribute('width', storedDims.width);
              svgElement.setAttribute('height', storedDims.height);
              svgElement.setAttribute('viewBox', `0 0 ${storedDims.width} ${storedDims.height}`);
              console.log("VECTORIZER: SVG Dimensionen korrigiert:", storedDims.width, "x", storedDims.height);
            }

            // Store original SVG without any modifications
            const serializer = new XMLSerializer();
            originalSvgString = serializer.serializeToString(svgElement);
            console.log('VECTORIZER: Original SVG gespeichert (ohne Filter)');

            // Apply styling directly to paths without filters for better consistency
            pathElements.forEach(path => {
              // Get current slider values
              const thicknessValue = parseFloat(document.getElementById('thickness-slider').value);
              const scaleValue = parseFloat(document.getElementById('scale-slider').value);
              
              // Calculate combined stroke width based on both sliders
              const combinedStrokeWidth = Math.max(0.1, thicknessValue + scaleValue - 1.0);
              
              path.setAttribute('fill', 'black');
              path.setAttribute('stroke', 'black');
              path.setAttribute('stroke-width', combinedStrokeWidth.toString());
              path.setAttribute('stroke-linejoin', 'round');
              path.setAttribute('stroke-linecap', 'round');
              path.setAttribute('vector-effect', 'non-scaling-stroke');
            });
            
            // Current SVG element for reference
            currentSvgElement = svgElement.cloneNode(true);
            
            // Display the result
            svgOutputContainer.innerHTML = '';
            svgOutputContainer.appendChild(svgElement);
            controlsWrapper.style.display = 'flex';
            setupControls();
            initializeStatusIndicators();
            
            
            console.log("VECTORIZER: SVG erfolgreich angezeigt");
          } catch (processingError) {
            console.error("VECTORIZER: SVG Verarbeitungsfehler:", processingError);
            svgOutputContainer.innerHTML = '<p style="color: red;">Fehler: ' + processingError.message + '</p>';
            if(uploadPrompt) uploadPrompt.style.display = 'flex';
            controlsWrapper.style.display = 'none';
          }
            });
          }, 'image/png');
        };
        
        img.onerror = function() {
          console.error("VECTORIZER: Fehler beim Laden des Bildes");
          svgOutputContainer.innerHTML = '<p style="color: red;">Fehler: Bild konnte nicht geladen werden</p>';
          if(uploadPrompt) uploadPrompt.style.display = 'flex';
          controlsWrapper.style.display = 'none';
        };
        
        // Load the original file into the image
        const reader = new FileReader();
        reader.onload = function(e) {
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
        
      } catch (err) {
        console.error("VECTORIZER: Potrace Fehler:", err);
        svgOutputContainer.innerHTML = '<p style="color: red;">Fehler: Bildverarbeitung fehlgeschlagen - ' + err.message + '</p>';
        if(uploadPrompt) uploadPrompt.style.display = 'flex';
        controlsWrapper.style.display = 'none';
      }
    }

    function downloadSvgDirectly() {
      console.log('VECTORIZER: Direkter SVG Download gestartet');
      
      const svgElement = document.querySelector('#svg-output svg');
      if (!svgElement) {
        console.error('VECTORIZER: Kein SVG zum Download verfügbar');
        alert('Kein SVG verfügbar. Bitte laden Sie zuerst ein Bild hoch.');
        return;
      }

      try {
        // Clone SVG and apply current settings
        const svgClone = svgElement.cloneNode(true);
        
        // Apply current stroke settings
        const thicknessValue = parseFloat(document.getElementById('thickness-slider')?.value || 0.5);
        const scaleValue = parseFloat(document.getElementById('scale-slider')?.value || 1.0);
        const combinedStrokeWidth = Math.max(0.1, thicknessValue + scaleValue - 1.0);
        
        console.log('VECTORIZER: Angewandte Einstellungen - Thickness:', thicknessValue, 'Scale:', scaleValue, 'Combined:', combinedStrokeWidth);
        
        svgClone.querySelectorAll('path').forEach(path => {
          path.setAttribute('stroke-width', combinedStrokeWidth.toString());
          path.setAttribute('fill', 'black');
          path.setAttribute('stroke', 'black');
        });

        // Add proper SVG namespace and attributes
        svgClone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        
        // Serialize to string
        const serializer = new XMLSerializer();
        let svgString = serializer.serializeToString(svgClone);
        
        // Add XML declaration if missing
        if (!svgString.startsWith('<?xml')) {
          svgString = '<?xml version="1.0" encoding="UTF-8"?>\n' + svgString;
        }
        
        console.log('VECTORIZER: SVG String erzeugt, Länge:', svgString.length);
        
        // Create download with better browser compatibility
        const blob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        
        // Alternative download method for better compatibility
        const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
        const filename = `gravur-${timestamp}.svg`;
        
        // Try different download approaches
        if (navigator.msSaveBlob) {
          // IE/Edge
          navigator.msSaveBlob(blob, filename);
        } else {
          // Modern browsers
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          a.download = filename;
          a.target = '_blank';
          
          document.body.appendChild(a);
          
          // Force click with timeout
          setTimeout(() => {
            a.click();
            setTimeout(() => {
              document.body.removeChild(a);
              URL.revokeObjectURL(url);
            }, 100);
          }, 100);
        }
        
        console.log('VECTORIZER: SVG Download initiiert für:', filename);
        
      } catch (error) {
        console.error('VECTORIZER: SVG Download Fehler:', error);
        alert('Fehler beim SVG Download: ' + error.message);
      }
    }

    function downloadPngDirectly() {
      console.log('VECTORIZER: Direkter PNG Download gestartet');
      
      const svgElement = document.querySelector('#svg-output svg');
      if (!svgElement) {
        console.error('VECTORIZER: Kein SVG zum PNG-Export verfügbar');
        alert('Kein SVG verfügbar. Bitte laden Sie zuerst ein Bild hoch.');
        return;
      }

      try {
        // Clone SVG and apply current settings
        const svgClone = svgElement.cloneNode(true);
        
        // Apply current stroke settings
        const thicknessValue = parseFloat(document.getElementById('thickness-slider')?.value || 0.5);
        const scaleValue = parseFloat(document.getElementById('scale-slider')?.value || 1.0);
        const combinedStrokeWidth = Math.max(0.1, thicknessValue + scaleValue - 1.0);
        
        console.log('VECTORIZER: PNG Export - Thickness:', thicknessValue, 'Scale:', scaleValue);
        
        svgClone.querySelectorAll('path').forEach(path => {
          path.setAttribute('stroke-width', combinedStrokeWidth.toString());
          path.setAttribute('fill', 'black');
          path.setAttribute('stroke', 'black');
        });

        // Add proper SVG namespace
        svgClone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        
        // Get SVG dimensions
        const svgRect = svgElement.getBoundingClientRect();
        const width = parseInt(svgClone.getAttribute('width')) || svgRect.width || 800;
        const height = parseInt(svgClone.getAttribute('height')) || svgRect.height || 600;
        
        console.log('VECTORIZER: PNG Dimensionen:', width, 'x', height);

        // Create canvas for PNG export
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = width;
        canvas.height = height;
        
        // White background
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, width, height);
        
        const img = new Image();
        
        img.onload = function() {
          try {
            ctx.drawImage(img, 0, 0, width, height);
            
            // Convert to PNG with multiple fallback methods
            if (canvas.toBlob) {
              canvas.toBlob(function(blob) {
                if (blob) {
                  const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
                  const filename = `gravur-${timestamp}.png`;
                  
                  if (navigator.msSaveBlob) {
                    navigator.msSaveBlob(blob, filename);
                  } else {
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.style.display = 'none';
                    a.href = url;
                    a.download = filename;
                    document.body.appendChild(a);
                    
                    setTimeout(() => {
                      a.click();
                      setTimeout(() => {
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                      }, 100);
                    }, 100);
                  }
                  
                  console.log('VECTORIZER: PNG Download initiiert für:', filename);
                } else {
                  throw new Error('PNG Blob konnte nicht erstellt werden');
                }
              }, 'image/png', 1.0);
            } else {
              // Fallback for older browsers
              const dataURL = canvas.toDataURL('image/png');
              const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
              const filename = `gravur-${timestamp}.png`;
              
              const a = document.createElement('a');
              a.href = dataURL;
              a.download = filename;
              a.click();
              
              console.log('VECTORIZER: PNG Download (Fallback) für:', filename);
            }
            
          } catch (canvasError) {
            console.error('VECTORIZER: Canvas Drawing Fehler:', canvasError);
            alert('Fehler beim PNG Export: ' + canvasError.message);
          }
        };
        
        img.onerror = function() {
          console.error('VECTORIZER: Fehler beim Laden des SVG für PNG Export');
          alert('Fehler: SVG konnte nicht für PNG Export geladen werden');
        };
        
        // Create SVG data URL
        const serializer = new XMLSerializer();
        let svgString = serializer.serializeToString(svgClone);
        
        // Ensure proper SVG format for image loading
        if (!svgString.includes('xmlns')) {
          svgString = svgString.replace('<svg', '<svg xmlns="http://www.w3.org/2000/svg"');
        }
        
        const svgDataUrl = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgString)));
        img.src = svgDataUrl;
        
      } catch (error) {
        console.error('VECTORIZER: PNG Download Fehler:', error);
        alert('Fehler beim PNG Download: ' + error.message);
      }
    }

    function previewSvgInNewTab() {
      console.log('VECTORIZER: SVG Vorschau in neuem Tab');
      
      const svgElement = document.querySelector('#svg-output svg');
      if (!svgElement) {
        console.error('VECTORIZER: Kein SVG für Vorschau verfügbar');
        return;
      }

      try {
        // Clone SVG and apply current settings
        const svgClone = svgElement.cloneNode(true);
        
        // Apply current stroke settings
        const thicknessValue = parseFloat(document.getElementById('thickness-slider').value);
        const scaleValue = parseFloat(document.getElementById('scale-slider').value);
        const combinedStrokeWidth = Math.max(0.1, thicknessValue + scaleValue - 1.0);
        
        svgClone.querySelectorAll('path').forEach(path => {
          path.setAttribute('stroke-width', combinedStrokeWidth.toString());
        });

        // Serialize to string
        const serializer = new XMLSerializer();
        const svgString = serializer.serializeToString(svgClone);
        
        // Create preview HTML
        const previewHtml = `
          <!DOCTYPE html>
          <html>
          <head>
            <title>SVG Vorschau</title>
            <style>
              body { margin: 0; padding: 20px; background: #f5f5f5; display: flex; justify-content: center; align-items: center; min-height: 100vh; }
              svg { max-width: 100%; max-height: 100%; background: white; box-shadow: 0 4px 12px rgba(0,0,0,0.1); }
            </style>
          </head>
          <body>
            ${svgString}
          </body>
          </html>
        `;
        
        const previewBlob = new Blob([previewHtml], { type: 'text/html' });
        const previewUrl = URL.createObjectURL(previewBlob);
        window.open(previewUrl, '_blank');
        
        console.log('VECTORIZER: SVG Vorschau geöffnet');
      } catch (error) {
        console.error('VECTORIZER: SVG Vorschau Fehler:', error);
      }
    }

    function setupControls() {
      console.log('VECTORIZER: Setting up controls...');
      
      const slider = document.getElementById('thickness-slider');
      const sliderValue = document.getElementById('slider-value');
      const scaleSlider = document.getElementById('scale-slider');
      const scaleValue = document.getElementById('scale-value');
      const detailSlider = document.getElementById('detail-slider');
      const detailValue = document.getElementById('detail-value');
      const cornerSlider = document.getElementById('corner-slider');
      const cornerValue = document.getElementById('corner-value');
      const downloadSvgBtn = document.getElementById('download-svg-btn');
      const downloadPngBtn = document.getElementById('download-png-btn');
      const previewSvgBtn = document.getElementById('preview-svg-btn');
      const contrastSlider = document.getElementById('contrast-slider');
      const brightnessSlider = document.getElementById('brightness-slider');
      const noiseReductionSlider = document.getElementById('noise-reduction-slider');
      
      console.log('VECTORIZER: Control elements found:');
      console.log('- thickness-slider:', !!slider);
      console.log('- scale-slider:', !!scaleSlider);
      console.log('- detail-slider:', !!detailSlider);
      console.log('- corner-slider:', !!cornerSlider);
      console.log('- download-svg-btn:', !!downloadSvgBtn);
      console.log('- download-png-btn:', !!downloadPngBtn);
      
      if (!slider || !sliderValue || !scaleSlider || !scaleValue || !downloadSvgBtn || !downloadPngBtn) {
        console.error("VECTORIZER: Steuerelemente nicht gefunden");
        console.error('Missing elements:', {
          slider: !!slider,
          sliderValue: !!sliderValue,
          scaleSlider: !!scaleSlider,
          scaleValue: !!scaleValue,
          downloadSvgBtn: !!downloadSvgBtn,
          downloadPngBtn: !!downloadPngBtn
        });
        return;
      }
      
      sliderValue.textContent = parseFloat(slider.value).toFixed(2);
      scaleValue.textContent = parseFloat(scaleSlider.value).toFixed(1);
      if (detailSlider && detailValue) detailValue.textContent = detailSlider.value;
      if (cornerSlider && cornerValue) cornerValue.textContent = parseFloat(cornerSlider.value).toFixed(1);
      
      // Remove existing event listeners to prevent duplicates
      slider.removeEventListener('input', sliderInputHandler);
      scaleSlider.removeEventListener('input', scaleInputHandler);
      if (detailSlider) detailSlider.removeEventListener('input', detailInputHandler);
      if (cornerSlider) cornerSlider.removeEventListener('input', cornerInputHandler);
      
      // Add event listeners
      slider.addEventListener('input', sliderInputHandler);
      scaleSlider.addEventListener('input', scaleInputHandler);
      if (detailSlider) detailSlider.addEventListener('input', detailInputHandler);
      if (cornerSlider) cornerSlider.addEventListener('input', cornerInputHandler);
      
      // Add new slider event listeners
      if (contrastSlider) contrastSlider.addEventListener('input', contrastInputHandler);
      if (brightnessSlider) brightnessSlider.addEventListener('input', brightnessInputHandler);
      if (noiseReductionSlider) noiseReductionSlider.addEventListener('input', noiseReductionInputHandler);
      
      // Add button event listeners
      if (downloadSvgBtn) downloadSvgBtn.addEventListener('click', downloadSvgDirectly);
      if (downloadPngBtn) downloadPngBtn.addEventListener('click', downloadPngDirectly);
      if (previewSvgBtn) previewSvgBtn.addEventListener('click', previewSvgInNewTab);
      
      // Setup optimization checkboxes
      setupOptimizationHandlers();
      setupImageCorrectionHandlers();
    }
    
    function sliderInputHandler() {
      console.log('VECTORIZER: Thickness slider changed to:', this.value);
      const sliderValue = document.getElementById('slider-value');
      
      if (sliderValue) {
        sliderValue.textContent = parseFloat(this.value).toFixed(2);
        updatePathStrokeWidths();
        console.log('VECTORIZER: Updated thickness to:', this.value);
      }
    }
    
    function scaleInputHandler() {
      console.log('VECTORIZER: Scale slider changed to:', this.value);
      const scaleValue = document.getElementById('scale-value');
      
      if (scaleValue) {
        const scaleVal = parseFloat(this.value);
        scaleValue.textContent = scaleVal.toFixed(1);
        updatePathStrokeWidths();
        console.log("VECTORIZER: Vektordicke geändert auf:", scaleVal);
      }
    }
    
    function detailInputHandler() {
      const detailValue = document.getElementById('detail-value');
      if (detailValue) {
        detailValue.textContent = this.value;
        // Note: Detail level affects the next image processing
        console.log("VECTORIZER: Detail-Level geändert auf:", this.value);
      }
    }
    
    function cornerInputHandler() {
      const cornerValue = document.getElementById('corner-value');
      if (cornerValue) {
        cornerValue.textContent = parseFloat(this.value).toFixed(1);
        // Note: Corner smoothing affects the next image processing
        console.log("VECTORIZER: Eckenglättung geändert auf:", this.value);
      }
    }
    
    function contrastInputHandler() {
      const contrastValue = document.getElementById('contrast-value');
      if (contrastValue) {
        contrastValue.textContent = parseFloat(this.value).toFixed(1);
        applyImageCorrections();
        console.log("VECTORIZER: Kontrast geändert auf:", this.value);
      }
    }
    
    function brightnessInputHandler() {
      const brightnessValue = document.getElementById('brightness-value');
      if (brightnessValue) {
        brightnessValue.textContent = parseFloat(this.value).toFixed(1);
        applyImageCorrections();
        console.log("VECTORIZER: Helligkeit geändert auf:", this.value);
      }
    }
    
    function noiseReductionInputHandler() {
      const noiseValue = document.getElementById('noise-value');
      if (noiseValue) {
        noiseValue.textContent = this.value;
        applyImageCorrections();
        console.log("VECTORIZER: Rauschunterdrückung geändert auf:", this.value);
      }
    }
    
    function setupOptimizationHandlers() {
      const optimizePaths = document.getElementById('optimize-paths');
      const removeHoles = document.getElementById('remove-holes');
      const simplifyCurves = document.getElementById('simplify-curves');
      
      if (optimizePaths) {
        optimizePaths.addEventListener('change', function() {
          console.log("VECTORIZER: Pfad-Optimierung:", this.checked);
          updateStatusIndicator('optimize-status', this.checked);
          applySVGOptimizations();
        });
      }
      
      if (removeHoles) {
        removeHoles.addEventListener('change', function() {
          console.log("VECTORIZER: Löcher schließen:", this.checked);
          updateStatusIndicator('holes-status', this.checked);
          applySVGOptimizations();
        });
      }
      
      if (simplifyCurves) {
        simplifyCurves.addEventListener('change', function() {
          console.log("VECTORIZER: Kurven vereinfachen:", this.checked);
          updateStatusIndicator('curves-status', this.checked);
          applySVGOptimizations();
        });
      }
      
      const smoothLines = document.getElementById('smooth-lines');
      if (smoothLines) {
        smoothLines.addEventListener('change', function() {
          console.log("VECTORIZER: Linien glätten:", this.checked);
          updateStatusIndicator('smooth-status', this.checked);
          applySVGOptimizations();
        });
      }
    }
    
    function applySVGOptimizations() {
      const svgElement = document.querySelector('#svg-output svg');
      if (!svgElement) return;
      
      const optimizePaths = document.getElementById('optimize-paths');
      const removeHoles = document.getElementById('remove-holes');
      const simplifyCurves = document.getElementById('simplify-curves');
      
      const paths = svgElement.querySelectorAll('path');
      
      paths.forEach(path => {
        let pathData = path.getAttribute('d');
        if (!pathData) return;
        
        // Remove tiny holes (close small gaps)
        if (removeHoles && removeHoles.checked) {
          pathData = pathData.replace(/M[\d\.\-\s,]+Z/g, function(match) {
            // Remove very small closed paths (likely holes)
            const coords = match.match(/[\d\.\-]+/g);
            if (coords && coords.length >= 4) {
              const minX = Math.min(...coords.filter((_, i) => i % 2 === 0).map(Number));
              const maxX = Math.max(...coords.filter((_, i) => i % 2 === 0).map(Number));
              const minY = Math.min(...coords.filter((_, i) => i % 2 === 1).map(Number));
              const maxY = Math.max(...coords.filter((_, i) => i % 2 === 1).map(Number));
              
              const area = (maxX - minX) * (maxY - minY);
              return area < 100 ? '' : match; // Remove small holes
            }
            return match;
          });
        }
        
        // Simplify curves
        if (simplifyCurves && simplifyCurves.checked) {
          pathData = pathData.replace(/C[\d\.\-\s,]+/g, function(match) {
            // Simplify complex curves to simpler ones
            return match.replace(/(\d+\.\d{3,})/g, function(num) {
              return parseFloat(num).toFixed(1);
            });
          });
        }
        
        // Optimize paths
        if (optimizePaths && optimizePaths.checked) {
          // Remove redundant commands and round coordinates
          pathData = pathData.replace(/\s+/g, ' ')
                            .replace(/(\d+\.\d{2,})/g, function(num) {
                              return parseFloat(num).toFixed(1);
                            });
        }
        
        path.setAttribute('d', pathData);
      });
      
      console.log("VECTORIZER: SVG-Optimierungen angewendet");
    }
    
    function updatePathStrokeWidths() {
      const svgElement = document.querySelector('#svg-output svg');
      if (!svgElement) return;
      
      const thicknessValue = parseFloat(document.getElementById('thickness-slider').value);
      const scaleValue = parseFloat(document.getElementById('scale-slider').value);
      
      // Calculate combined stroke width
      const combinedStrokeWidth = Math.max(0.1, thicknessValue + scaleValue - 1.0);
      
      const paths = svgElement.querySelectorAll('path');
      paths.forEach(path => {
        path.setAttribute('stroke-width', combinedStrokeWidth.toString());
      });
      
      console.log('VECTORIZER: Path stroke widths updated to:', combinedStrokeWidth);
    }
    
    function setupImageCorrectionHandlers() {
      const autoThreshold = document.getElementById('auto-threshold');
      const invertColors = document.getElementById('invert-colors');
      const edgeEnhancement = document.getElementById('edge-enhancement');
      
      if (autoThreshold) {
        autoThreshold.addEventListener('change', function() {
          console.log("VECTORIZER: Auto-Schwellenwert:", this.checked);
          updateStatusIndicator('threshold-status', this.checked);
          applyImageCorrections();
        });
      }
      
      if (invertColors) {
        invertColors.addEventListener('change', function() {
          console.log("VECTORIZER: Farben invertieren:", this.checked);
          updateStatusIndicator('invert-status', this.checked);
          applyImageCorrections();
        });
      }
      
      if (edgeEnhancement) {
        edgeEnhancement.addEventListener('change', function() {
          console.log("VECTORIZER: Kanten verstärken:", this.checked);
          updateStatusIndicator('edge-status', this.checked);
          applyImageCorrections();
        });
      }
    }
    
    function applyImageCorrections() {
      const svgElement = document.querySelector('#svg-output svg');
      if (!svgElement) return;
      
      const invertColors = document.getElementById('invert-colors');
      const contrast = parseFloat(document.getElementById('contrast-slider').value);
      const brightness = parseFloat(document.getElementById('brightness-slider').value);
      
      const paths = svgElement.querySelectorAll('path');
      paths.forEach(path => {
        let fill = 'black';
        let stroke = 'black';
        
        // Invert colors if checked
        if (invertColors && invertColors.checked) {
          fill = 'white';
          stroke = 'white';
          // Add black background to SVG
          if (!svgElement.querySelector('rect.bg')) {
            const bg = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
            bg.setAttribute('class', 'bg');
            bg.setAttribute('width', '100%');
            bg.setAttribute('height', '100%');
            bg.setAttribute('fill', 'black');
            svgElement.insertBefore(bg, svgElement.firstChild);
          }
        } else {
          // Remove background if not inverted
          const bg = svgElement.querySelector('rect.bg');
          if (bg) bg.remove();
        }
        
        path.setAttribute('fill', fill);
        path.setAttribute('stroke', stroke);
        
        // Apply brightness and contrast as opacity
        const opacity = Math.min(1, Math.max(0.1, brightness * contrast));
        path.setAttribute('opacity', opacity.toString());
      });
      
      console.log('VECTORIZER: Bildkorrekturen angewendet');
    }
    
    function updateStatusIndicator(indicatorId, isActive) {
      const indicator = document.getElementById(indicatorId);
      if (indicator) {
        if (isActive) {
          indicator.textContent = '🟢'; // Green circle
          indicator.title = 'Aktiv';
        } else {
          indicator.textContent = '🔴'; // Red circle
          indicator.title = 'Inaktiv';
        }
      }
    }
    
    function initializeStatusIndicators() {
      // Initialize status indicators based on default checkbox states
      const optimizePaths = document.getElementById('optimize-paths');
      const removeHoles = document.getElementById('remove-holes');
      const simplifyCurves = document.getElementById('simplify-curves');
      const smoothLines = document.getElementById('smooth-lines');
      const autoThreshold = document.getElementById('auto-threshold');
      const invertColors = document.getElementById('invert-colors');
      const edgeEnhancement = document.getElementById('edge-enhancement');
      
      if (optimizePaths) {
        updateStatusIndicator('optimize-status', optimizePaths.checked);
      }
      if (removeHoles) {
        updateStatusIndicator('holes-status', removeHoles.checked);
      }
      if (simplifyCurves) {
        updateStatusIndicator('curves-status', simplifyCurves.checked);
      }
      if (smoothLines) {
        updateStatusIndicator('smooth-status', smoothLines.checked);
      }
      if (autoThreshold) {
        updateStatusIndicator('threshold-status', autoThreshold.checked);
      }
      if (invertColors) {
        updateStatusIndicator('invert-status', invertColors.checked);
      }
      if (edgeEnhancement) {
        updateStatusIndicator('edge-status', edgeEnhancement.checked);
      }
    }
    
  }

  // Initialize when everything is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForPotrace);
  } else {
    waitForPotrace();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
